import { forwardRef, memo, useEffect, useImperativeHandle, useState } from 'react';
import { query_purchased_equity_list } from '@/sub-luca-plugin/apis';
import EmptyData from '../equity-render/empty-data';
import './index.scss';

export interface IRechargeRecordRenderContext {
    refresh: () => Promise<any>;
}

interface IProps {
    projectId?: number;
}

const RechargeRecordRender = ({ projectId }: IProps, ref: any) => {
    const [orderRecords, setOrderRecords] = useState<any[]>();

    const initPayedList = async (projectId: number) => {
        const { result } = await query_purchased_equity_list({ projectId });
        if (result) {
            const processedRecords = result.orderRecords.map((item: any) => {
                const newItem = { ...item };
                if (!result.aiCorrectAuth) {
                    newItem.aiCorrectNum = undefined;
                    newItem.aiCorrectNumStr = undefined;
                }
                if (!result.manualCorrectAuth) {
                    newItem.manualCorrectNum = undefined;
                    newItem.manualCorrectNumStr = undefined;
                }
                return newItem;
            });
            setOrderRecords(processedRecords);
        }
    };

    useImperativeHandle(
        ref,
        () => ({
            refresh: () => projectId && initPayedList(projectId),
        }),
        [projectId]
    );

    useEffect(() => {
        if (projectId) {
            initPayedList(projectId);
        }
    }, [projectId]);

    if (orderRecords?.length === 0) return <EmptyData className="recharge-record-empty-container" />;

    return (
        <div className="rights-list-box">
            {!!orderRecords?.length && (
                <>
                    {orderRecords.map((item, i) => (
                        <div key={Date.now() + String(i)} className="pay-item">
                            <div className="pay-name">{item.equityTitle}</div>
                            <div className="pay-tips">
                                luca答疑次数：<span>{item.lucaAskNumStr}</span>
                            </div>
                            <div className="pay-tips">
                                名师答疑次数：<span>{item.teacherAskNumStr}</span>
                            </div>
                            {item.aiCorrectNumStr && (
                                <div className="pay-tips">
                                    智能批改次数：<span>{item.aiCorrectNumStr}</span>
                                </div>
                            )}
                            {item.manualCorrectNumStr && (
                                <div className="pay-tips">
                                    人工批改次数：<span>{item.manualCorrectNumStr}</span>
                                </div>
                            )}
                            <div className="pay-tips">
                                有效期至：<span>{item.expireDate}</span>
                            </div>
                            <div className="pay-money">
                                ¥ <span>{item.amount}</span>
                            </div>
                        </div>
                    ))}
                </>
            )}
        </div>
    );
};

export default memo(forwardRef(RechargeRecordRender));
